
"use client";
import { useEffect } from "react";
export default function GTMScript({Gtm_Id}:any) {
  useEffect(() => {
    const GTM_ID = Gtm_Id;
    if (!GTM_ID) return;
    const worker = new Worker(
      new URL("./gtm.worker.ts", import.meta.url), 
      { type: "module" }
    );
    
    worker.postMessage({ GTM_ID });
    worker.onmessage = ({ data }) => {
     
      const { start, event } = data as {
        start: number;
        event: string;
        GTM_ID: string;
      };
      (window as any).dataLayer = (window as any).dataLayer || [];
      window.dataLayer.push({ "gtm.start": start, event });

      // Finally load the GTM script itself
      const gtmScript = document.createElement("script");
      gtmScript.async = true;
      gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
      document.head.appendChild(gtmScript);
      return () => worker.terminate();
    };
  }, []);

  return null;
}
